(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brewBodyTabs"]) return;
  try {
    
  // TAB clicker
  $('.tab-heading').click(function(){
    var tab_id = $(this).attr('data-id')
    var tabcon = $('.tab-content')

    if($(this).hasClass('active')){
    }else{
      $(this).addClass('active');
      $(this).siblings().removeClass('active');
    }

    tabcon.each(function(){
      var curr_id = $(this).attr('data-id');
      if(curr_id == tab_id){
        $(this).addClass('active');
        $(this).siblings().removeClass('active');  
      }
    })
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collectionDefault"]) return;
  try {
    
  /* keep boxes checked if checked */
  checkedBoxes();

  function checkedBoxes() {
    var checkbox = $('.filter-checkboxes input');
    var currentPath = window.location.href.split('/');
    var pathString = currentPath[currentPath.length - 1];

    checkbox.each(function () {
      if ($(this).attr('value') === pathString) {
        $(this).attr('checked', true);
        $(this).parent().parent().removeClass('inactive');
        $(this).parent().parent().addClass('active');
      }
    });
  }

  /* Sidebar cat arrow */
  var arrowIconArray = document.querySelectorAll('.icon');
  arrowIconArray.forEach((arrowIcon) => {
    arrowIcon.addEventListener('click', function () {
      var arrowID = arrowIcon.id;

      if (arrowID === 'type') {
        var typeFilter = document.querySelector('#type-checkboxes');
        var classList = typeFilter.classList;

        if (classList.contains('active')) {
          typeFilter.classList.remove('active');
          typeFilter.classList.add('inactive');
        } else {
          typeFilter.classList.remove('inactive');
          typeFilter.classList.add('active');
        }
      }
      if (arrowID === 'flavours') {
        var flavFilter = document.querySelector('#sub-type-checkboxes');
        var classList = flavFilter.classList;

        if (classList.contains('active')) {
          flavFilter.classList.remove('active');
          flavFilter.classList.add('inactive');
        } else {
          flavFilter.classList.add('active');
          flavFilter.classList.remove('inactive');
        }
      }
      if (arrowID === 'machine1') {
        var brandFilter = document.querySelector('#brand-checkboxes');
        var classList = brandFilter.classList;

        if (classList.contains('active')) {
          brandFilter.classList.remove('active');
          brandFilter.classList.add('inactive');
        } else {
          brandFilter.classList.add('active');
          brandFilter.classList.remove('inactive');
        }
      }
      if (arrowID === 'machine2') {
        var brandFilter2 = document.querySelector('#brand-checkboxes2');
        var classList = brandFilter2.classList;

        if (classList.contains('active')) {
          brandFilter2.classList.remove('active');
          brandFilter2.classList.add('inactive');
        } else {
          brandFilter2.classList.add('active');
          brandFilter2.classList.remove('inactive');
        }
      }
      if (arrowID === 'grinder1') {
        var brandFilter3 = document.querySelector('#brand-checkboxes3');
        var classList = brandFilter3.classList;

        if (classList.contains('active')) {
          brandFilter3.classList.remove('active');
          brandFilter3.classList.add('inactive');
        } else {
          brandFilter3.classList.add('active');
          brandFilter3.classList.remove('inactive');
        }
      }
      if (arrowID === 'products') {
        var prodFilter = document.querySelector('#prod-checkboxes');
        var classList = prodFilter.classList;

        if (classList.contains('active')) {
          prodFilter.classList.remove('active');
          prodFilter.classList.add('inactive');
        } else {
          prodFilter.classList.add('active');
          prodFilter.classList.remove('inactive');
        }
      }
    });
  });

  /* Product Tag Filters - Good for any number of filters on any type of collection pages */

  /* Coffee sidebar filter action */
  const collFilters = document.querySelectorAll('.coll-filter');
  const filterBtnCoffee = document.querySelector('#filter-coffee-btn');

  if (collFilters.length > 0) {
    collFilters.forEach((collFilter) => {
      collFilter.addEventListener('change', function () {
        var thisBox = $(this)[0].value;
        var query = thisBox;
        window.location.href = '/collections/coffee/' + query;
      });
    });
  }

  /* Machines sidebar filter action */
  const mcollFilters = document.querySelectorAll('.mcoll-filter');
  const filterBtnMachine = document.querySelector('#filter-machine-btn');

  if (mcollFilters.length > 0) {
    mcollFilters.forEach((mcollFilter) => {
      mcollFilter.addEventListener('change', function () {
        var thisBox = $(this)[0].value;
        var mquery = thisBox;
        window.location.href = '/collections/coffee-machines-and-grinders/' + mquery;
      });
    });
  }

  /* Accessories sidebar filter action */
  const acollFilters = document.querySelectorAll('.acoll-filter');
  const filterBtnAcc = document.querySelector('#filter-accessories-btn');

  if (acollFilters.length > 0) {
    acollFilters.forEach((acollFilter) => {
      acollFilter.addEventListener('change', function () {
        var thisBox = $(this)[0].value;
        var aquery = thisBox;
        window.location.href = '/collections/Accessories/' + aquery;
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newCollection"]) return;
  try {
    
  /* keep boxes checked if checked */
  checkedBoxes();

  function checkedBoxes() {
    var segments = window.location.pathname.split('/').filter(Boolean);
    if (segments.length < 3) return;

    var pathString = decodeURIComponent(segments[segments.length - 1]);

    /* Scope to the current collection's own filters, since a tag value such as
       Cold-brew appears under both Coffee and Equipment. */
    var scopes = {
      coffee: '.coll-filter',
      'coffee-machines-and-grinders': '.mcoll-filter',
      accessories: '.acoll-filter',
    };
    var scope = scopes[segments[1].toLowerCase()];
    if (!scope) return;

    $(scope).each(function () {
      if ($(this).attr('value').toLowerCase() === pathString.toLowerCase()) {
        $(this).attr('checked', true);
        $(this).parent().parent().removeClass('inactive');
        $(this).parent().parent().addClass('active');
      }
    });
  }

  /* Sidebar cat arrow */
  var arrowIconArray = document.querySelectorAll('.icon');
  arrowIconArray.forEach((arrowIcon) => {
    arrowIcon.addEventListener('click', function () {
      var arrowID = arrowIcon.id;

      if (arrowID === 'type') {
        var typeFilter = document.querySelector('#type-checkboxes');
        var classList = typeFilter.classList;

        if (classList.contains('active')) {
          typeFilter.classList.remove('active');
          typeFilter.classList.add('inactive');
        } else {
          typeFilter.classList.remove('inactive');
          typeFilter.classList.add('active');
        }
      }
      if (arrowID === 'flavours') {
        var flavFilter = document.querySelector('#sub-type-checkboxes');
        var classList = flavFilter.classList;

        if (classList.contains('active')) {
          flavFilter.classList.remove('active');
          flavFilter.classList.add('inactive');
        } else {
          flavFilter.classList.add('active');
          flavFilter.classList.remove('inactive');
        }
      }
      if (arrowID === 'machine1') {
        var brandFilter = document.querySelector('#brand-checkboxes');
        var classList = brandFilter.classList;

        if (classList.contains('active')) {
          brandFilter.classList.remove('active');
          brandFilter.classList.add('inactive');
        } else {
          brandFilter.classList.add('active');
          brandFilter.classList.remove('inactive');
        }
      }
      if (arrowID === 'machine2') {
        var brandFilter2 = document.querySelector('#brand-checkboxes2');
        var classList = brandFilter2.classList;

        if (classList.contains('active')) {
          brandFilter2.classList.remove('active');
          brandFilter2.classList.add('inactive');
        } else {
          brandFilter2.classList.add('active');
          brandFilter2.classList.remove('inactive');
        }
      }
      if (arrowID === 'grinder1') {
        var brandFilter3 = document.querySelector('#brand-checkboxes3');
        var classList = brandFilter3.classList;

        if (classList.contains('active')) {
          brandFilter3.classList.remove('active');
          brandFilter3.classList.add('inactive');
        } else {
          brandFilter3.classList.add('active');
          brandFilter3.classList.remove('inactive');
        }
      }
      if (arrowID === 'products') {
        var prodFilter = document.querySelector('#prod-checkboxes');
        var classList = prodFilter.classList;

        if (classList.contains('active')) {
          prodFilter.classList.remove('active');
          prodFilter.classList.add('inactive');
        } else {
          prodFilter.classList.add('active');
          prodFilter.classList.remove('inactive');
        }
      }
    });
  });

  /* Product Tag Filters - Good for any number of filters on any type of collection pages */

  /* Coffee sidebar filter action */
  const collFilters = document.querySelectorAll('.coll-filter');
  const filterBtnCoffee = document.querySelector('#filter-coffee-btn');

  if (collFilters.length > 0) {
    collFilters.forEach((collFilter) => {
      collFilter.addEventListener('change', function () {
        var thisBox = $(this)[0].value;
        if (this.checked) {
          window.location.href = '/collections/coffee/' + thisBox;
        } else {
          window.location.href = '/collections/coffee';
        }
      });
    });
  }

  /* Machines sidebar filter action */
  const mcollFilters = document.querySelectorAll('.mcoll-filter');
  const filterBtnMachine = document.querySelector('#filter-machine-btn');

  if (mcollFilters.length > 0) {
    mcollFilters.forEach((mcollFilter) => {
      mcollFilter.addEventListener('change', function () {
        var thisBox = $(this)[0].value;
        if (this.checked) {
          window.location.href = '/collections/coffee-machines-and-grinders/' + thisBox;
        } else {
          window.location.href = '/collections/coffee-machines-and-grinders';
        }
      });
    });
  }

  /* Accessories sidebar filter action */
  const acollFilters = document.querySelectorAll('.acoll-filter');
  const filterBtnAcc = document.querySelector('#filter-accessories-btn');

  if (acollFilters.length > 0) {
    acollFilters.forEach((acollFilter) => {
      acollFilter.addEventListener('change', function () {
        var thisBox = $(this)[0].value;
        if (this.checked) {
          window.location.href = '/collections/Accessories/' + thisBox;
        } else {
          window.location.href = '/collections/Accessories';
        }
      });
    });
  }

  /* Sort By dropdown (sort links use full page reload) */
  (function () {
    function closeAllSortMenus() {
      document.querySelectorAll('[data-collection-sort-menu]').forEach(function (menu) {
        menu.setAttribute('hidden', '');
      });
      document.querySelectorAll('[data-collection-sort-trigger]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-collection-sort-trigger]');
      if (trigger) {
        e.stopPropagation();
        var wrap = trigger.closest('[data-collection-sort]');
        var menu = wrap && wrap.querySelector('[data-collection-sort-menu]');
        if (!menu) return;
        var isOpen = !menu.hasAttribute('hidden');
        closeAllSortMenus();
        if (!isOpen) {
          menu.removeAttribute('hidden');
          trigger.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      if (!e.target.closest('[data-collection-sort]')) {
        closeAllSortMenus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllSortMenus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new_brewBodyTabs"]) return;
  try {
    
  // TAB clicker
  $('.tab-heading').click(function(){
    var tab_id = $(this).attr('data-id')
    var tabcon = $('.tab-content')

    if($(this).hasClass('active')){
    }else{
      $(this).addClass('active');
      $(this).siblings().removeClass('active');
    }

    tabcon.each(function(){
      var curr_id = $(this).attr('data-id');
      if(curr_id == tab_id){
        $(this).addClass('active');
        $(this).siblings('.tab-content').removeClass('active');  
      }
    })
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }

        /* Slider code end */
        $('.alt-slider').slick({
          slidesToShow: 4,
          autoplay: false,
          loop: false,
          arrows: true,
          dots: true,
          prevArrow: $('.arrow_prev_alt'),
          nextArrow: $('.arrow_next_alt'),
          appendDots: $('.product-alt-dots'),
          slidesToScroll: 1,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 1100,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                arrows: true,
              },
            },
          ],
        });
        /* Slider code end */
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 180px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-summary-v2"] && !Shopify.designMode) return;
  try {
    
  // Initialize Klaviyo reviews if available
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Klaviyo !== 'undefined' && document.getElementById('klaviyo-reviews-summary')) {
      const reviewsContainer = document.getElementById('klaviyo-reviews-summary');
      const productId = reviewsContainer.getAttribute('data-id');

      // This will be handled by Klaviyo's script when it loads
      // You may need to customize this based on your Klaviyo setup
    }
  });

  } catch(e) { console.error(e); }
})();
})();
